// client/src/modules/technician/index.ts
import type { ModuleManifest } from '../types';
import { routes } from './routes';
import { navItems } from './nav';

/**
 * Technician module manifest (P12)
 *
 * AI-powered pre-service briefings, senior tech curation,
 * and smart job assistant for field technicians.
 */
export const technicianModule: ModuleManifest = {
  id: 'P12',
  name: 'Technician',
  shortName: 'Technician',
  description: 'Pre-service briefings, AI job assistant, and senior technician curation',
  icon: '\uD83D\uDCCB',
  status: 'live',
  urlPrefix: '/technician',
  routes,
  navItems,
  collections: {
    JOB_BRIEFINGS: 'jobBriefings',
    TRAINING_DATA: 'trainingData',
    EQUIPMENT_PROFILES: 'equipmentProfiles',
    IMAGE_ANALYSIS: 'imageAnalysis',
    PROBLEM_PATTERNS: 'problemPatterns',
    EXPERT_TIPS: 'expertTips',
    CURATION_ACTIVITY: 'curationActivity',
    CURATOR_STATS: 'curatorStats',
  },
};

export default technicianModule;
